(() => {
  'use strict';
  const key = Symbol.for('seldravinpack.productInformation.initialize');
  if (window[key]) { window[key](document); return; }
  const instances = new Map();
  function create(root) {
    const controller = new AbortController();
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    let animation;
    const listen = (node, type, fn) => node.addEventListener(type, fn, { signal: controller.signal });
    function select(index, focus = false) {
      if (!tabs[index]) return;
      animation?.cancel();
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
      if (focus) tabs[index].focus();
      if (!reduced.matches) animation = panels[index].animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
    }
    tabs.forEach((tab, index) => {
      listen(tab, 'click', () => select(index));
      listen(tab, 'keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
    listen(root, 'shopify:block:select', event => {
      let index = tabs.findIndex(tab => tab.dataset.tabBlock === String(event.detail?.blockId));
      if (index < 0) index = panels.findIndex(panel => panel.contains(event.target));
      select(index);
    });
    listen(reduced, 'change', () => animation?.cancel());
    return { destroy() { controller.abort(); animation?.cancel(); } };
  }
  function initialize(scope) {
    const roots = [...scope.querySelectorAll('[data-product-information]')];
    if (scope.matches?.('[data-product-information]')) roots.unshift(scope);
    roots.forEach(root => { if (!instances.has(root)) instances.set(root, create(root)); });
  }
  function remove(root) { instances.get(root)?.destroy(); instances.delete(root); }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => { [...instances.keys()].forEach(root => { if (event.target === root || event.target.contains(root)) remove(root); }); });
  new MutationObserver(() => { [...instances.keys()].forEach(root => { if (!root.isConnected) remove(root); }); }).observe(document.documentElement, { childList: true, subtree: true });
  window[key] = initialize;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true }); else initialize(document);
})();
